import React from "react";
import { RichTextReference } from "./types";
import GatsbyImage from "../GatsbyImage";

type Props = {
  reference: RichTextReference;
  caption: string;
};

export default function ImageWithCaption({ reference, caption }: Props) {
  return (
    <figure className="rich-text__figure" data-testid="image-with-caption">
      <GatsbyImage
        alt={reference.description || ""}
        image={reference.gatsbyImageData}
      />
      <figcaption>{caption}</figcaption>
    </figure>
  );
}
